/* eslint-disable camelcase */
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PhotoGallery from '../../../../shared/components/PhotoGallery/PhotoGallery';
import { get } from 'lodash-es';
import ResponsiveHeader from '../../../../shared/components/ResponsiveHeader';

function Brand({ offer }) {
  const { t } = useTranslation();

  const {
    brand_name,
    brand_description,
    brand_key_links,
    brand_instagram_profile,
    products,
    product_images
  } = offer;

  const isEvent = get(products, '0.rtype') === 'event admission'

  return (
    <div className='page'>
      <Container>
        <Row>
          <Col xs={12} sm={7}>
            <h3 className="mb-6">{t('influencers.pages.campaign.brand.about_brand')}</h3>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={7}>
            <h5 dangerouslySetInnerHTML={{ __html: t('influencers.pages.campaign.brand.about_company', { company_name: brand_name }) }} />
            <div className="mb-5" dangerouslySetInnerHTML={{ __html: brand_description }} />

            {isEvent && <ResponsiveHeader xs="h5">{t('influencers.pages.campaign.glance.event')}</ResponsiveHeader>}
            {products && <section className="mb-5">
              {products.map(product => (<article key={product.id}>
                <h5>{product.name}</h5>
                <div dangerouslySetInnerHTML={{ __html: product.desc }} />
              </article>))}
            </section>}

            {product_images && <section className="mb-5">
              {isEvent
                ? <ResponsiveHeader xs="h5">{t('influencers.pages.campaign.brand.event_gallery')}</ResponsiveHeader>
                : <ResponsiveHeader xs="h5">{t('influencers.pages.campaign.brand.product_gallery')}</ResponsiveHeader>}
              <PhotoGallery xs={1} sm={3} lg={4} preloadedImages={product_images} />
            </section>}
          </Col>

          <Col xs={12} sm={5}>
            {brand_key_links && <section>
              <h5>{t('influencers.pages.campaign.brand.key_links')}</h5>
              <div dangerouslySetInnerHTML={{ __html: brand_key_links }} />
            </section>}
          </Col>
        </Row>

        {brand_instagram_profile && <Row>
          <Col>
            <h5>{t('influencers.pages.campaign.brand.from_their_feeds')}</h5>
            <PhotoGallery xs={1} sm={3} lg={4} username={brand_instagram_profile} platform={'instagram'} />
          </Col>
        </Row>}
      </Container>
    </div>
  );
}

export default Brand;